module.exports = __webpack_public_path__ + "static/media/20_tn.bbcb85f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/20_tn.jpg
// module id = 234
// module chunks = 0